import { useEffect } from "react";

const useScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    document.body.style.overflow = isLocked ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isLocked]);
};

export default useScrollLock;
